import * as React from 'react';
import styled from 'styled-components/macro';

import { colors, distances } from '../styles/constants';
import { H2 } from './Typography';

interface CardProps {
    children: any;
    title?: any;
    subtitle?: string;
    noPadding?: boolean;
    marginBottom?: string;
    shortHr?: boolean;
    id?: string;
    fitContent?: boolean;
    className?: string;
}

const Card = (props: CardProps) => {
    return (
        <CardWrapper
            className={props.className}
            noPadding={props.noPadding}
            marginBottom={props.marginBottom}
            fitContent
        >
            {props.title && (
                <TitleWrapper noPadding={props.noPadding}>
                    <H2 id={props.id}>{props.title}</H2>
                    <CardSubtitle>{props.subtitle}</CardSubtitle>
                    {props.shortHr ? <ShortCardHr /> : <CardHr />}
                </TitleWrapper>
            )}
            {props.children}
        </CardWrapper>
    );
};

interface WrapperProps {
    noPadding?: boolean;
    marginBottom?: string;
    fitContent?: boolean;
}

const TitleWrapper = styled.div<WrapperProps>`
    padding: ${(props) => (props.noPadding ? distances.normal : '0')};
    padding-top: ${(props) => (props.noPadding ? distances.small : '0')};
    padding-bottom: 0;
`;

interface WrapperProps {
    noPadding?: boolean;
    marginBottom?: string;
    fitContent?: boolean;
}

const CardWrapper = styled.section<WrapperProps>`
    background: ${colors.background};
    color: ${colors.text};
    padding: ${(props) => (props.noPadding ? '0' : distances.normal)};
    margin-bottom: ${(props) => props.marginBottom || '0px'};
    max-width: 1200px;
    width: 100%;
    border-radius: 4px;
    position: relative;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
    height: ${(props) => (props.fitContent ? 'fit-content' : 'auto')};

    @media (max-width: 768px) {
        padding: ${(props) => (props.noPadding ? '0' : distances.small)};

        & > h4, p {
            margin: 0;
        }

        display: flex;
        flex-direction: column;

        gap: ${distances.small};
    }
`;

const CardHr = styled.hr`
    margin: ${distances.tiny} -${distances.normal};
    padding: 0;
    border: 0;
    height: 2px;
    background: ${colors.borderLight};
`;

const ShortCardHr = styled.hr`
    padding: 0;
    border: 0;
    height: 2px;
    background: ${colors.borderLight};
`;

const CardSubtitle = styled(H2 as any)`
    color: ${colors.borderDark};
`;

export default Card;
